<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          FAQ
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            FAQ List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getData">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              label="Search by category"
              single-line
              hide-details
              @keyup="searchFaq()"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <v-btn
              id="add-texts"
              depressed
              color="secondblue"
              class="white--text"
              :to="{ name: 'faqCreate' }"
            >
              <v-icon left dark>add</v-icon>
              ADD FAQ
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :must-sort="true"
            :loading="progressDialogLoading"
            :options.sync="options"
            :server-items-length="totalItems"
            :sort-desc.sync="descending"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, 25]
            }"
          >
            <v-progress-linear
              slot="progress"
              color="primary"
              indeterminate
            ></v-progress-linear>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                :id="'btn-detail' + item.id"
                @click="toDetail(item.id)"
                v-if="hasPermission('view_master_data', 'view')"
              >
                <v-icon color="green">remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                icon
                :id="'btn-edit' + item.id"
                @click="toEdit(item.id)"
                v-if="hasPermission('update_master_data', 'update')"
              >
                <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
              </v-btn>
              <v-btn
                :id="'btn-edit' + item.id"
                @click="deleteItem(item.id)"
                icon
                v-if="hasPermission('delete_master_data', 'delete')"
              >
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:no-data>
              <label>No data displayed</label>
            </template>
          </v-data-table>
        </v-col>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'Content Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'FAQ List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      items: [],
      headers: [
        { text: 'Category', value: 'name' },
        { text: 'Created At', value: 'created_at' },
        { text: 'Updated At', value: 'updated_at' },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      page: 1,
      pageCount: 0,
      search: '',
      isSearch: false
    };
  },
  watch: {
    descending() {
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchFaq() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.progressDialogLoading = true;
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      return this.$store
        .dispatch('support/getAll', {
          page,
          sort,
          limit: itemsPerPage,
          name: this.search
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            // this.options = data.data.pagination;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this data',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          this.$store.dispatch('support/deleteFaq', id).then(data => {
            this.progressDialogLoading = false;
            Swal.fire('Deleted!', data.message.text_en, 'success');
            this.getData();
          });
        }
      });
    },
    toDetail(value) {
      this.$router.push({
        name: 'faqDetail',
        params: { id: value, type: 'Detail' }
      });
    },
    toEdit(value) {
      this.$router.push({
        name: 'faqEdit',
        params: { id: value, type: 'Edit' }
      });
    }
  }
};
</script>
